module.exports = __webpack_public_path__ + "static/img/yzzx.6184074.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/course/yzzx.png
// module id = Ul/u
// module chunks = 0